export default "__VITE_ASSET__yZD0fVWf__"